import type { DLClickEventProps } from 'tsconfig/types';
import { adobeDataLayer } from './AdobeDataLayer';

interface StateSelectorDLHandlers {
  trackImpression: () => void;
  trackSelection: (stateName: string, clickError?: string) => void;
}

export function createStateSelectorDLHandlers(): StateSelectorDLHandlers {
  const pageType = adobeDataLayer.getPageType();
  const eventType = 'stateSelector';

  // Push this event when the state selector is first presented to a
  // new website visitor(i.e.not when a user has triggered the state selector by clicking the
  // state selector option in the main header)
  function trackImpression() {
    const data: DLClickEventProps = {
      clickDescription: `${pageType}: state selector: impression`,
      clickName: 'state selector impression',
      clickLocation: 'state selector',
      clickText: 'impression',
      clickAction: 'state selector impression',
    };
    adobeDataLayer.clickEvent(eventType, data);
  }

  // Push this event when the user clicks the “Enter” button from the state selector that
  // has been presented to a new website visitor, and if selected a state we currently
  // don’t ship then clickError will be populated with the error message:
  function trackSelection(stateName: string, clickError = '') {
    const data: DLClickEventProps = {
      clickDescription: `${pageType}: state selector: ${stateName}: enter click`,
      clickName: 'state selector enter click',
      clickLocation: 'state selector',
      clickText: 'enter',
      clickAction: 'state selector enter click',
      clickError,
    };

    adobeDataLayer.removeEvent(eventType);
    adobeDataLayer.clickEvent(eventType, data);
  }

  return {
    trackImpression,
    trackSelection,
  };
}
